var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7483_28184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_710_6219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 0H0V18H18V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7483_28184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.64 9.20457C17.64 8.56638 17.5828 7.95276 17.4764 7.36362H9V10.845H13.8436C13.635 11.97 13.001 12.9232 12.0478 13.5614V15.8196H14.9564C16.6582 14.2528 17.64 11.9454 17.64 9.20457Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.00004 18C11.43 18 13.4673 17.194 14.9563 15.8196L12.0477 13.5614C11.2418 14.1014 10.2109 14.4204 9.00004 14.4204C6.6559 14.4204 4.67185 12.8372 3.96409 10.71H0.957275V13.0418C2.43823 15.9832 5.48185 18 9.00004 18Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.96405 10.71C3.78405 10.17 3.68181 9.59319 3.68181 9C3.68181 8.40681 3.78405 7.83 3.96405 7.29V4.95819H0.95724C0.34776 6.17319 0 7.54776 0 9C0 10.4522 0.34776 11.8268 0.95724 13.0418L3.96405 10.71Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.00004 3.57957C10.3213 3.57957 11.5077 4.03362 12.4405 4.92543L15.0218 2.34405C13.4632 0.89181 11.4259 0 9.00004 0C5.48185 0 2.43823 2.01681 0.957275 4.95819L3.96409 7.29C4.67185 5.16276 6.6559 3.57957 9.00004 3.57957Z",
    fill: "#E94235"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon-google.d872b2a44e7fa51c393c18a9a3487c83.svg";
export { ForwardRef as ReactComponent };